import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ADMIN_ROUTES } from '@/lib/admin-routes';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: 'customer' | 'filmmaker' | 'admin';
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login page with return URL
    return <Navigate to={`/login?returnUrl=${encodeURIComponent(location.pathname)}`} replace />;
  }

  // Check role if required
  if (requiredRole && !user?.roles.includes(requiredRole)) {
    // Redirect to appropriate dashboard based on available roles
    let redirectPath = '/dashboard'; // Default fallback
    if (user?.roles.includes('customer')) {
      redirectPath = '/dashboard';
    } else if (user?.roles.includes('filmmaker')) {
      redirectPath = '/filmmaker';
    } else if (user?.roles.includes('admin')) {
      redirectPath = ADMIN_ROUTES.BASE;
    }
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}